import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";

import { fetchDashboards } from "../../../store/actions/dashsActions";
import { fetchGroups } from "../../../store/actions/groupsActions";
import Logo from '../../../assets/logo.svg';
import './Sidebar.css';

function Sidebar({ activePage, user, userDb, isOpen, toggleSidebar }) {
  const dispatch = useDispatch();
  const { dashs } = useSelector((state) => state.dashs);
  const { groups } = useSelector((state) => state.groups);
  const emConstrucao = true;
  const userRole = user?.role;

  const fallbackURL = "https://firebasestorage.googleapis.com/v0/b/sizmek-datorama.appspot.com/o/profiles%2Fthumbnails%2Ffaff2e10-2402-4a89-9106-7f10c6aec022.jpg?alt=media&token=802169d6-72e3-4f86-a0c4-a61feb5edf4e";
  const [imgLoaded, setImgLoaded] = useState(false);
  const [salesEmail, setSalesEmail] = useState([
    "marcelo@adsmovil.com", "jonas@adsmovil.com", "florencia.barea@adsmovil.com", "claudia.patino@adsmovil.com", "karina@adsmovil.com", "tamires@adsmovil.com", "ruzito@gmail.com", "raul@adsmovil.com"
  ])
  const [salesEmailAdmin, setSalesEmailAdmin] = useState([
    "marcelo@adsmovil.com", "tamires@adsmovil.com", "ruzito@gmail.com", "raul@adsmovil.com"
  ])
  const isSales = () => salesEmail.some(s => s === user.email);
  const isSalesAdmin = () => salesEmailAdmin.some(s => s === user.email);
  const resultadoSales = isSales();
  const resultadoSalesAdmin = isSalesAdmin();
  useEffect(() => {
    if (!userDb?.photoURL) return;

    const img = new Image();
    img.src = userDb.photoURL;
  }, [userDb?.photoURL]);

  const sidebarRef = useRef();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        isOpen &&
        window.innerWidth <= 768 &&
        sidebarRef.current &&
        !sidebarRef.current.contains(event.target)
      ) {
        toggleSidebar(); // Fecha ao clicar fora
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen, toggleSidebar]);


  const [openSubMenu, setOpenSubMenu] = useState("");
  const [isDisabled, setIsDisabled] = useState({
    submenu1: false,
    submenu2: false,
  });


  useEffect(() => {
    dispatch(fetchDashboards());
    dispatch(fetchGroups());
  }, [dispatch]);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768 && !isOpen) {
        toggleSidebar(); // Abre automaticamente em desktop, opcional
      }
      //if (window.innerWidth <= 768 && isOpen) {
      //toggleSidebar(); // Fecha em telas pequenas se estiver aberta
      //}
    };

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, [isOpen, toggleSidebar]);


  const toggleSubMenu = (menuId) => {
    if (isDisabled[menuId]) return;
    setOpenSubMenu((prev) => (prev === menuId ? "" : menuId));
  };

  const isActive = (path) => (activePage === path ? "active" : "");

  const userUID = user?.uid;
  const userGroups = groups.filter((group) => group.readers.includes(userUID));
  const dashIdsInGroups = userGroups.flatMap((group) => group.dashboardsId);

  const dashsOnly = dashs.filter(
    (dash) =>
      dash.readers?.includes(userUID) && !dashIdsInGroups.includes(dash.id)
  );

  const handleLogout = () => {
    localStorage.removeItem("authToken");
  }

  const handleLinkClick = () => {
    if (window.innerWidth <= 768) {
      toggleSidebar(); // fecha menu no mobile
    }
  };

  function formatName(fullName) {
    if (!fullName) return "Nome do usuário";
    
    const parts = fullName.trim().split(/\s+/); // divide por espaços
    const firstName = parts[0];
    const lastName = parts[1] || ""; // pega o primeiro sobrenome se existir

    return `${firstName} ${lastName}`.trim();
  }

  return (
    <nav
      ref={sidebarRef}
      id="menu"
      className={`menu sidebar ${isOpen ? "show" : ""}`}
    >

      <div className="header">
        {isOpen && <img src={Logo} alt="Logo" className="logo" />}
        <button
          className={`hamburger-sidebar ${isOpen ? "open" : ""}`}
          onClick={toggleSidebar}
        >
          <i className="fa fa-bars hamburgerIcon" />
        </button>
      </div>

      {isOpen && (
        <>
          <div className="profile showProfile">
            <img
              src={userDb?.photoURL ?? fallbackURL}
              alt="Foto de Perfil"
              className={`perfilPhoto ${imgLoaded ? "loaded" : ""}`}
              onLoad={() => setImgLoaded(true)}
            />
            <h3>
              {userDb.userName
                ? formatName(`${userDb.userName} ${userDb.userLastname}`)
                : formatName(userDb.displayName)}
            </h3>
          </div>

          <div className="menuContent showContent">
            <ul>
              <li className={isActive("/dashboard")}>
                <Link to="/dashboard" onClick={handleLinkClick}>
                  Home
                </Link>
              </li>

              <li className="menuItem" onClick={() => toggleSubMenu("submenu1")}>
                <span className="submenuIcon">
                  Dashboards
                  <i
                    className={`fa ${openSubMenu === "submenu1" ? "fa-chevron-up" : "fa-chevron-down"
                      } submenuIcon`}
                  />
                </span>

                {openSubMenu === "submenu1" && !isDisabled.submenu1 && (
                  <ul
                    id="submenu1"
                    className={`submenu ${openSubMenu === "submenu1" ? "open" : ""}`}
                  >
                    {userGroups.map((group) => (
                      <li key={group.uid} className="group-section">
                        <span className="group-section-item-father">
                          {group.groupName}
                        </span>
                        <ul>
                          {group.dashboardsId.map((dashId) => {
                            const dashboard = dashs.find((d) => d.id === dashId);
                            if (!dashboard) return null;
                            return (
                              <li className="group-section-item" key={dashId}>
                                <a
                                  href={`/render/${dashId}`}
                                  onClick={handleLinkClick}
                                  rel="noopener noreferrer"
                                  title={
                                    dashboard.dashboardDescription || "Sem descrição"
                                  }
                                >
                                  {dashboard.dashboardName}
                                </a>
                              </li>
                            );
                          })}
                        </ul>
                      </li>
                    ))}

                    <li key="avulsos" className="group-section">
                      <span className="group-section-item-father">
                        Dashboards Avulsos
                      </span>
                      <ul>
                        {dashsOnly.map((dash) => (
                          <li className="group-section-item-brother" key={dash.id}>
                            <a
                              href={`/render/${dash.id}`}
                              onClick={handleLinkClick}
                              rel="noopener noreferrer"
                              title={dash.dashboardDescription || "Sem descrição"}
                            >
                              {dash.dashboardName}
                            </a>
                          </li>
                        ))}
                      </ul>
                    </li>
                  </ul>
                )}
              </li>

              <li className={isActive("/perfil")}>
                <Link to="/perfil" onClick={handleLinkClick}>
                  Sua Conta
                </Link>
              </li>

              {(resultadoSales || user?.isAdmin) && (
                <li className="menuItem" onClick={() => toggleSubMenu("submenuPropostas")}>
                  <span className="submenuIcon">
                    Gerenciar Propostas
                    <i
                      className={`fa ${openSubMenu === "submenuPropostas" ? "fa-chevron-up" : "fa-chevron-down"} submenuIcon`}
                    />
                  </span>

                  {openSubMenu === "submenuPropostas" && (
                    <ul
                      id="submenuPropostas"
                      className={`submenu ${openSubMenu === "submenuPropostas" ? "open" : ""}`}
                    >
                      <li className={isActive("/propostaComercial")}>
                        <Link to="/propostaComercial" onClick={handleLinkClick}>
                          Nova Proposta
                        </Link>
                      </li>

                       <li>
                        <Link to="/ProposalsReviewPage" onClick={handleLinkClick}>
                          Histórico de Proposta
                        </Link>
                    </li>

                    {(user?.isAdmin || resultadoSalesAdmin) && (
                        <li className={isActive("/adminConfigPropostaComercial")}>
                          <Link to="/adminConfigPropostaComercial" onClick={handleLinkClick}>
                            Configuração 
                          </Link>
                        </li>
                      )}
                    </ul>
                  )}
                </li>
              )}

              {userDb?.isAdmin && (
              <li className="menuItem" onClick={() => toggleSubMenu("submenu2")}>
                <span className="submenuIcon">
                  Configurações de BI
                  <i
                    className={`fa ${openSubMenu === "submenu2" ? "fa-chevron-up" : "fa-chevron-down"
                      } submenuIcon`}
                  />
                </span>
                {openSubMenu === "submenu2" && !isDisabled.submenu2 && (
                  <ul
                    id="submenu2"
                    className={`submenu ${openSubMenu === "submenu2" ? "open" : ""}`}
                  >
                    <li>
                      <Link to="/criarUsuario" onClick={handleLinkClick}>
                        Novo Usuário
                      </Link>
                    </li>
                    <li>
                      <Link to="/criarDash" onClick={handleLinkClick}>
                        Novo Dashboard
                      </Link>
                    </li>
                    <li>
                      <Link to="/criarGrupo" onClick={handleLinkClick}>
                        Novo Grupo
                      </Link>
                    </li>
                    <li>
                      <Link to="/gerenciar" onClick={handleLinkClick}>
                        Gerenciar Recursos
                      </Link>
                    </li>
                    <li>
                        <Link to="/aprovacaoDeAcessos" onClick={handleLinkClick}>
                          Acessos Pendentes
                        </Link>
                    </li>

                  </ul>
                )}
              </li>)}

              <li>
                <a
                  href="https://support.flashtalking.com/hc/en-us"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="link"
                >
                  Documentação
                </a>
              </li>

              <li>
                <Link to="/" onClick={handleLogout}>
                  Sair
                </Link>
              </li>
            </ul>
          </div>

          <div className="footer">Copyright © 2024</div>
        </>
      )}
    </nav>
  );
}

export default Sidebar;
